import { GoogleAnalyticsService } from "../services/analytics/google-analytics.service";
import { EventAggregator, type Subscription } from "aurelia-event-aggregator";
import { Messages } from "../constants/event-messages.constants";

export class GoogleAnalyticsHelper {

    //Subscribe all events for Google Analytics tracking in one place
    public static subscribeEvents(subscriptions: Subscription[], googleAnalyticsService: GoogleAnalyticsService, eventAggregator: EventAggregator) {          
        
        //Subscribe button clicks
        subscriptions.push(eventAggregator.subscribe(Messages.buttonClick, buttonData => {

            const dimensions = {
                "button": buttonData.buttonName,
                "function": buttonData.functionName 
            }

            googleAnalyticsService.sendCustomGA4EventMulti("button_pressed", dimensions);
        }))

        //Subscribe card clicks (RightStore product cards)
        subscriptions.push(eventAggregator.subscribe(Messages.cardClick, cardData => {

            const dimensions = {
                "cardCategory": cardData.cardCategory,
                "card": cardData.card 
            }

            googleAnalyticsService.sendCustomGA4EventMulti("card_clicked", dimensions);
        }))

        //Subscribe combo box selections
        subscriptions.push(eventAggregator.subscribe(Messages.comboSelected, comboBoxData => {
            googleAnalyticsService.sendCustomGA4EventMulti("combo_selected", 
                {"comboBox" : comboBoxData.comboBoxLabel, "comboItemSelected" : comboBoxData.itemSelected, "isMulti": false})
        }));

        //Subscribe multi combo box selections
        subscriptions.push(eventAggregator.subscribe(Messages.multiComboSelected, multiData => {
            googleAnalyticsService.sendCustomGA4EventMulti("combo_selected", 
                {"comboBox" : multiData.multiSelect, "comboItemSelected" : multiData.itemsSelected, "isMulti": true})
        }));
    }
}